import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BannerPicture } from "@faire/retailer-visitor-shared/views/brand/BrandHeader/BannerPicture";
import { FaireDirectSectionErrorFallback } from "@faire/retailer-visitor-shared/views/faire-direct/__internal__/FaireDirectSectionErrorFallback";
import { useSearchProductsFromBrandQuery } from "@faire/retailer-visitor-shared/views/faire-direct/__internal__/useSearchProductsFromBrandQuery/useSearchProductsFromBrandQuery";
import { BrandPreview } from "@faire/retailer-visitor-shared/views/faire-direct/components/BrandPreview";
import { useUserPerceivedLoadTimingWithKey } from "@faire/web--source/common/performance/userPerceivedLoadTiming/useUserPerceivedLoadTiming";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { IRetailerBrandFollow } from "@faire/web-api--source/indigofair/data/IRetailerBrandFollow";
import * as React from "react";
import styled from "styled-components";
var BANNER_IMAGE_HEIGHT = 200;
export var BrandPreviewWithBanner = function(param) {
    var brand = param.brand, brandToken = param.brandToken, pageJsExecutedMark = param.pageJsExecutedMark;
    var _brand_brand_reviews_summary, _data_pagination_data;
    var _useSearchProductsFromBrandQuery = useSearchProductsFromBrandQuery(), data = _useSearchProductsFromBrandQuery.data, isPending = _useSearchProductsFromBrandQuery.isPending, isError = _useSearchProductsFromBrandQuery.isError, dataUpdatedAt = _useSearchProductsFromBrandQuery.dataUpdatedAt;
    var pageLoadKey = "page-faire-direct-landing-page-".concat(brandToken);
    var loadTimingRef = useUserPerceivedLoadTimingWithKey({
        name: "page-faire-direct-landing",
        pageLoadKey: pageLoadKey,
        dataUpdatedAt: dataUpdatedAt,
        numComponents: 2,
        isPageLoading: isPending,
        pageJsExecutedMark: pageJsExecutedMark,
        enableTrackPerformanceBreakdown: "internal-tracking",
        // This is needed because of the sign-up query param that immediately follows on landing.
        enablePageUpdateFix: true
    });
    var brandPreview = IRetailerBrandFollow.build({
        brand_based_in_city: brand.based_in_city,
        brand_based_in_state: brand.based_in_state,
        brand_first_order_minimum: brand.first_order_minimum_amount,
        brand_name: brand.name,
        brand_overall_rating: (_brand_brand_reviews_summary = brand.brand_reviews_summary) === null || _brand_brand_reviews_summary === void 0 ? void 0 : _brand_brand_reviews_summary.average_rating,
        brand_profile_image: brand.profile_image,
        brand_reorder_minimum: brand.reorder_minimum_amount,
        brand_token: brand.token
    });
    var _data_product_tiles;
    var productTiles = (_data_product_tiles = data === null || data === void 0 ? void 0 : data.product_tiles) !== null && _data_product_tiles !== void 0 ? _data_product_tiles : [];
    var totalProductCount = data === null || data === void 0 ? void 0 : (_data_pagination_data = data.pagination_data) === null || _data_pagination_data === void 0 ? void 0 : _data_pagination_data.total_results;
    if (isError) {
        return /*#__PURE__*/ _jsx(FaireDirectSectionErrorFallback, {});
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BannerContainer, {
                ref: loadTimingRef,
                children: /*#__PURE__*/ _jsx(BannerPicture, {
                    brandImage: brand.banner_image
                })
            }),
            /*#__PURE__*/ _jsx(BrandContainer, {
                children: /*#__PURE__*/ _jsx(BrandPreview, {
                    brand: brand,
                    item: brandPreview,
                    totalProductCount: totalProductCount,
                    productTiles: productTiles,
                    loadTimingRef: loadTimingRef
                })
            })
        ]
    });
};
var BannerContainer = styled.div.withConfig({
    componentId: "sc-cae0d39e-0"
})([
    "width:100%;height:",
    "px;"
], BANNER_IMAGE_HEIGHT);
var BrandContainer = styled.div.withConfig({
    componentId: "sc-cae0d39e-1"
})([
    "padding:55px 55px 0;",
    "{padding:32px 22px 0;}"
], responsiveMediaQueries.tabletAndBelow);
